module.exports = __webpack_public_path__ + "img/2_61.78c558a0.png";